const MOCK_DELAY_MS = 300;

const sleep = (duration) =>
	new Promise((resolve) => {
		setTimeout(resolve, duration);
	});

const createId = () => `filter-${Date.now()}-${Math.random().toString(16).slice(2, 8)}`;

let savedFilters = [
	{
		id: createId(),
		name: "Inbound Priority",
		criteria: {
			searchItem: "priority",
			searchSite: "ATL",
			shipFrom: "DAL",
			shipTo: "ATL",
			carrier: "Coca Logistics",
			shipMode: "Truck",
			shipmentTypes: {
				inbound: true,
				outbound: false,
				loads: true,
			},
		},
	},
	{
		id: createId(),
		name: "Outbound Bulk",
		criteria: {
			searchItem: "bulk",
			searchSite: "MIA",
			shipFrom: "MIA",
			shipTo: "LAX",
			carrier: "Oceanic",
			shipMode: "Ocean",
			shipmentTypes: {
				inbound: false,
				outbound: true,
				loads: false,
			},
		},
	},
];

export const fetchSavedFilters = async () => {
	await sleep(MOCK_DELAY_MS);
	return savedFilters.map((filter) => ({ ...filter }));
};

export const upsertSavedFilter = async (filter) => {
	await sleep(MOCK_DELAY_MS);

	const { id, name, criteria } = filter;
	if (!name) {
		throw new Error("Filter name is required");
	}

	const existingIndex = id
		? savedFilters.findIndex((entry) => entry.id === id)
		: -1;

	if (existingIndex >= 0) {
		savedFilters[existingIndex] = {
			...savedFilters[existingIndex],
			name,
			criteria,
		};
		return { ...savedFilters[existingIndex] };
	}

	const newFilter = {
		id: createId(),
		name,
		criteria,
	};

	savedFilters = [newFilter, ...savedFilters];
	return { ...newFilter };
};

export const deleteSavedFilter = async (id) => {
	await sleep(MOCK_DELAY_MS);
	savedFilters = savedFilters.filter((filter) => filter.id !== id);
};

